export interface IDashboardAuditsData{
    count: number;
    title?: string;
    opened: number;
    inAudit: number;
    finished: number;
    group?: number; 
    id: number;
}

export interface IDashboardAuditsDataPieChart{
	name: string;
	value: number;
}
	
export const colorChart = [
	"var(--purple)",
	"var(--blue)",
	"var(--green)"
];
